import { render, staticRenderFns } from "./CSolidColor.vue?vue&type=template&id=43489ab8&scoped=true"
import script from "./CSolidColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSolidColor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CSolidColor.vue?vue&type=style&index=0&id=43489ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43489ab8",
  null
  
)

export default component.exports